import { Component, OnInit } from '@angular/core';
import { GlobalVariables } from 'src/app/data/global-variables';
import { Company, ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-historic-demo',
  templateUrl: './historic-demo.component.html',
  styleUrls: ['./historic-demo.component.css']
})
export class HistoricDemoComponent implements OnInit {

  company!: Company;
  public Company = Company;
  public alert = alert;

  showingDocuments: string[] | null = null;
  documentIndex: number = 0;

  selected = -1;

  lastStudyExpanded = false;

  lastStudy = {
    id: 0,
    type: 'study',
    img: 'assets/demo-img/brain_mr.jpg',
    description: 'Estudio de resonancia magnética cerebral',
    doctor: 'Guillermo Ruiz',
    specialty: 'Diagnóstico por imagen',
    modality: 'MR',
    date: new Date('2024-01-20')
  };

  studies = [
    {
      id: 1,
      type: 'study',
      img: 'assets/demo-img/CT_heart.jpg',
      description: 'Tomografía de tórax',
      doctor: 'Guillermo Ruiz',
      specialty: 'Diagnóstico por imagen',
      modality: 'CT',
      date: new Date('2023-05-04')
    },
    {
      id: 2,
      type: 'study',
      img: 'assets/demo-img/brain_mr.jpg',
      description: 'Estudio de resonancia magnética cerebral',
      doctor: 'Guillermo Ruiz',
      specialty: 'Diagnóstico por imagen',
      modality: 'MR',
      date: new Date('2023-04-11')
    },
    {
      id: 3,
      type: 'study',
      img: 'assets/demo-img/chest_dx.jpg',
      description: 'Radiografía de Tórax',
      doctor: 'Guillermo Ruiz',
      specialty: 'Diagnóstico por imagen',
      modality: 'DX',
      date: new Date('2023-04-11')
    },

    // {
    //   id: 2,
    //   type: 'report',
    //   img: 'assets/demo-img/informe_alta.png',
    //   imgs: ['assets/demo-img/informe_alta.png'],
    //   description: 'Informe de alta médica',
    //   doctor: 'Guillermo Ruiz',
    //   specialty: 'Otros',
    //   date: new Date(new Date().getTime() - 2600000000)
    // },

    {
      id: 4,
      type: 'video',
      img: 'assets/demo-img/heart.png',
      imgs: ['assets/demo-img/heart.mp4'],
      description: 'Reconstrucción corazón',
      doctor: 'Guillermo Ruiz',
      specialty: 'Diagnóstico por imagen',
      date: new Date('2022-10-04')
    },
    {
      id: 5,
      type: 'study',
      img: 'assets/demo-img/CT_heart.jpg',
      description: 'Tomografía de tórax',
      doctor: 'Guillermo Ruiz',
      specialty: 'Diagnóstico por imagen',
      modality: 'CT',
      date: new Date('2022-10-04')
    },
    {
      id: 6,
      type: 'study',
      img: 'assets/demo-img/CT_heart.jpg',
      description: 'Tomografía de tórax',
      doctor: 'Guillermo Ruiz',
      specialty: 'Diagnóstico por imagen',
      modality: 'CT',
      date: new Date('2022-05-25')
    },
    {
      id: 7,
      type: 'image',
      img: 'assets/demo-img/ecg.jpg',
      imgs: ['assets/demo-img/ecg.jpg'],
      description: 'Electrocardiograma',
      doctor: 'Guillermo Ruiz',
      specialty: 'Urgencias',
      date: new Date('2021-12-24')
    },
    {
      id: 8,
      type: 'laboratory',
      img: 'assets/demo-img/lab.png',
      imgs: ['assets/demo-img/lab.png'],
      description: 'Análisis de laboratorio',
      doctor: 'Guillermo Ruiz',
      specialty: 'Laboratorio',
      date: new Date('2021-09-10')
    },
    {
      id: 9,
      type: 'report',
      img: 'assets/demo-img/colon_report.png',
      imgs: ['assets/demo-img/colon_report.png', 'assets/demo-img/colon_image.png'],
      description: 'Informe de Colonoscopia',
      doctor: 'Guillermo Ruiz',
      specialty: 'Informe externo',
      date: new Date('2021-08-18')
    },
    {
      id: 10,
      type: 'image',
      img: 'assets/demo-img/Densitometria-1.png',
      imgs: ['assets/demo-img/Densitometria-1.png', 'assets/demo-img/Densitometria-2.png', 'assets/demo-img/Densitometria-3.png', 'assets/demo-img/Densitometria-4.png'],
      description: 'Densitometría ósea',
      doctor: 'Guillermo Ruiz',
      specialty: 'Diagnóstico por imagen',
      date: new Date('2018-05-11')
    },
    {
      id: 11,
      type: 'report',
      img: 'assets/demo-img/consulta.png',
      imgs: ['assets/demo-img/consulta.png'],
      description: 'Consulta neurología',
      doctor: 'Guillermo Ruiz',
      specialty: 'Consulta de Especialidad',
      date: new Date('2016-10-10')
    },
    {
      id: 12,
      type: 'report',
      img: 'assets/demo-img/informe_2.png',
      imgs: ['assets/demo-img/informe_2.png'],
      description: 'Resonancia magnética de hombro',
      doctor: 'Guillermo Ruiz',
      specialty: 'Informe externo',
      date: new Date('2015-03-11')
    }
  ]

  get last6MonthStudies() {
    return this.studies.filter(st => st.date.getTime() >= (new Date().getTime() - 15550000000))
  }

  get lastYearStudies() {
    return this.studies.filter(st => st.date.getTime() > (new Date().getTime() - 31540000000) && st.date.getTime() < (new Date().getTime() - 7777000000))
  }

  get oldestStudies() {
    return this.studies.filter(st => st.date.getFullYear() < 2021);
    // return this.studies.filter(st => st.date.getTime() <= (new Date().getTime() - 31540000000))
  }

  studiesByYear(year: number) {
    return this.studies.filter(st => st.date.getFullYear() == year);
  }

  constructor(
    public globalVariables: GlobalVariables,
    private configService: ConfigService
  ) { }

  ngOnInit(): void {
    this.refreshCompany();
    console.log('last6MonthStudies: ', this.last6MonthStudies);
    console.log('lastYearStudies: ', this.lastYearStudies);
    console.log('oldestStudies: ', this.oldestStudies);

  }

  refreshCompany() {
    this.company = this.configService.company;
    if (this.company == Company.NOT_DEFINED) {
      setTimeout(() => {
        this.refreshCompany();
      }, 200);
    }
  }

  select(id: number) {
    if (this.selected == id) {
      this.selected = -1;
    } else {
      this.selected = id;
    }
  }

  openBook() {
    // window.open('/book-pdf?tkn=demoMR_STPLUS')
    window.location.href = '/book-pdf?tkn=demoMR_STPLUS'
  }

  openVisor() {
    // window.open('/book-pdf?tkn=demoMR_STPLUS')
    console.log('Abriendo visor...');
    let studyUID = '1';
    this.configService.getConfig().then(c => {
      const route = `${c.visorRoute}?sid=${studyUID}`;
      let visorWindow = window.open(route, 'Visor', 'toolbar=no,top=10,left=10,width=' + (screen.width - 50) + ',height=' + (screen.height - 100));
    })
  }

  openDocument(st: any) {
    document.getElementById('modalContainer')!.focus();
    this.documentIndex = 0;
    this.showingDocuments = st.imgs;
  }

  closeDocument() {
    this.showingDocuments = null;
    this.documentIndex = 0;
  }

}
